import '@naturehouse/design-system/components/atoms/tool-tip/ToolTip';
import type Dialog from '@naturehouse/design-system/components/molecules/dialog/Dialog';
import '../app/webComponents/CopyToClipboardTextArea';
import '../calendar/webComponents/AvailabilityCalendar';
import Module from '../module';
import CheckUnreadChatMessagesComponent from '../shared/components/CheckUnreadChatMessagesComponent';
import ConfirmValueComponent from '../shared/components/ConfirmValueComponent';
import ModalComponent from '../shared/components/ModalComponent';
import ChatChannelListComponent from '../shared/components/chatChannelListComponent';
import AcceptBookingComponent from './components/AcceptBookingComponent';
import './components/BookingSearch';
import './components/BookingsTable';
import './components/DeleteDiscountForm';
import DepositBookingComponent from './components/DepositBookingComponent';
import EditBookingComponent from './components/EditBookingComponent';
import './components/IframeControl';
import './components/LandlordRegistrationForm';
import RejectBookingComponent from './components/RejectBookingComponent';
import '../../../css/components/rental-wizard-calendar.pcss';
import '../../../css/views/landlord.pcss';

export default class LandlordModule extends Module {
    readonly #landlordRegistrationButton: NodeListOf<HTMLButtonElement> | null = null;

    readonly #landlordRegistrationModal: Dialog | null = null;

    constructor() {
        super();

        this.components.push(ConfirmValueComponent);
        this.components.push(AcceptBookingComponent);
        this.components.push(DepositBookingComponent);
        this.components.push(RejectBookingComponent);
        this.components.push(EditBookingComponent);
        this.components.push(ChatChannelListComponent);
        this.components.push(ModalComponent);
        this.components.push(CheckUnreadChatMessagesComponent);

        this.#landlordRegistrationButton = document.querySelectorAll(
            '[data-role="landlord-registration-button"]'
        );

        this.#landlordRegistrationModal = document.querySelector('#landlord-register-dialog');

        this.#landlordRegistrationButton?.forEach((el: HTMLButtonElement) =>
            el.addEventListener('click', (event: Event) => {
                event.preventDefault();
                this.#landlordRegistrationModal?.showModal();
            })
        );

        this.#initializeDialogButtons();
    }

    #initializeDialogButtons(): void {
        const buttons: HTMLButtonElement[] = Array.from(
            document.querySelectorAll('button[data-role="open-dialog"]')
        );

        for (const button of buttons) {
            button.addEventListener('click', () => {
                const target = button.dataset.target ?? '';
                const dialog = document.getElementById(target) as Dialog;

                if (!dialog) {
                    return;
                }

                dialog.showModal();

                const form = dialog.querySelector('form');
                const action = button.dataset.formAction;

                if (!action || !form) {
                    return;
                }

                form.action = action;
            });
        }
    }
}

(function landlordInit(): void {
    const landlordModule = new LandlordModule();
    landlordModule.init();
})();
